export default __webpack_public_path__ + "alberta-phone.60b7ec43c1b491977f14.svg";